import React from "react";
import { Container, Fade, Row } from "reactstrap";
import CertificationCard from "components/CertificationCard";
import '../assets/css/index.css';
import { certificates } from '../portfolio.js';

const Certifications = () => {
	return (
		<section className="section section-lg">
			<Container>
				<Fade bottom duration={1000} distance="40px">
					<div className="d-flex p-4">
						<div>
							<div className="icon icon-lg icon-shape bg-gradient-white shadow rounded-circle text-info">
								<i className="fa fa-star text-info" />
							</div>
						</div>
						<div className="pl-4">
							<h4 className="display-3 text-info">
								Certifications
							</h4>
						</div>
					</div>					
					<Row className="d-flex align-items-center" >
						{
							certificates.map((data, i) => {
								return <CertificationCard key={i} data={data} />
							})
						}
                	</Row>					
				</Fade>
			</Container>
		</section>
	);
};

export default Certifications;